import { runningClientSide } from '@benzinga/utils';

export const extractUtmParamsFromUrl = (urlString: string): Record<string, string> => {
  if (!runningClientSide()) return {};

  const url = new URL(urlString);
  const urlParams = url.searchParams;
  const utmParams: Record<string, string> = {};

  urlParams.forEach((value, key) => {
    if (key.startsWith('utm_') && value) {
      utmParams[key.replace('utm_', '')] = value;
    }
  });

  return utmParams;
};
